import { Devices } from "../../DeviceAdapter";
import { GrooveAdapter } from "../../grooves/GrooveBoxAdapter";
export class ZeitgeistDeviceBoxAdapter {
    type = "midi-effect";
    accepts = "midi";
    #context;
    #box;
    constructor(context, box) {
        this.#context = context;
        this.#box = box;
        this.groove(); // force creation of GrooveAdapter
    }
    get box() { return this.#box; }
    get uuid() { return this.#box.address.uuid; }
    get address() { return this.#box.address; }
    get indexField() { return this.#box.index; }
    get labelField() { return this.#box.label; }
    get enabledField() { return this.#box.enabled; }
    get minimizedField() { return this.#box.minimized; }
    get host() { return this.#box.host; }
    deviceHost() {
        return this.#context.boxAdapters
            .adapterFor(this.#box.host.targetVertex.unwrap("no device-host").box, Devices.isHost);
    }
    groove() {
        return this.#context.boxAdapters
            .adapterFor(this.#box.groove.targetVertex.unwrap("no groove").box, GrooveAdapter.checkType);
    }
    catchupAndSubscribeGroove(observer) {
        return this.#box.groove.catchupAndSubscribe(pointer => observer(this.#context.boxAdapters
            .adapterFor(pointer.targetVertex.unwrap("No groove found").box, GrooveAdapter.checkType)));
    }
    audioUnitBoxAdapter() { return this.deviceHost().audioUnitBoxAdapter(); }
    terminate() { }
}
